import {Price} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardProperty,
} from '@flexinet/ui-components';
import {Link} from 'react-router-dom';
import {Text} from '@mantine/core';

import {useAllowedItems} from '../../../hooks/useAllowedProperties.ts';
import {PriceStatusBadge} from './PriceStatusBadge.tsx';
import {PriceDisplayBadge} from './PriceDisplayBadge.tsx';

export const InformationPropertyCard = ({record}: { record: Price }) => {

    const productLabel = record.product?.name || record.productId;
    const ratePlanLabel = record.ratePlan?.name || record.ratePlanId;

    const properties = [
        {
            label: 'ID',
            value: record.id as string,
            span: 12,
        }, {
            label: 'Status',
            value: <PriceStatusBadge record={record}/>,
            span: 12,
        }, {
            label: 'Amount',
            value: <PriceDisplayBadge record={record}/>,
            span: 12,
        }, {
            label: 'Pricing Model',
            value: record.pricingModel as string,
            span: 12,
        }, {
            label: 'Product',
            value: record.productId ? (
                <Link to={`/products/${record.productId}`} style={{textDecoration: 'none'}}>
                    <Text c="blue" style={{cursor: 'pointer'}}>{productLabel}</Text>
                </Link>
            ) : 'n/a',
            span: 12,
        }, {
            label: 'Rate Plan',
            value: ratePlanLabel as string,
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const {filterAllowed} = useAllowedItems();
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    return (<PlatformPropertyCard properties={allowedProperties}/>);
};
